import React from 'react'
import "./Logo.scss"
const Logo = () => {
  return (
    <div className='Logo_title'>MyLuckyGems</div>
  )
}

export default Logo